import axios from 'axios';

// Switch backend with ONE line in .env.local:
//   REACT_APP_API_TARGET=local   → local backend (http://localhost:2112/backend)
//   REACT_APP_API_TARGET=prod    → production (default when unset)
// Or run: npm run start:local  /  npm run start:prod  (no file edit needed).
// REACT_APP_API_BASE_URL still works for a fully custom URL and wins over the target.
const TARGETS = {
  local: 'http://localhost:2112/backend',
  prod: 'https://backend.polbol.in/backend',
};
const target = (process.env.REACT_APP_API_TARGET || 'prod').toLowerCase();
export const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || TARGETS[target] || TARGETS.prod;

export default axios.create({
  baseURL: apiBaseUrl,
  headers: {
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem('p-x-auth')}`;
      }
    }
  }
});
